export const DEFAULT_PROMO_CODE = "firstsips23";

// States we don't ship to; a user geolocated here gets the restricted-state
// error screen instead of box filling
export const RESTRICTED_SHIPPING_STATES = ["RI", "UT"];

export const CREATION_SOURCES = {
  INTRO_BONUS: "intro_bonus",
  ADHOC_BONUS: "adhoc_bonus",
  INTRO_EXTRA: "intro_extra",
  BONUS: "bonus",
  FWC: "fwc-upgrade",
  FREE_RECURRING: "free_recurring",
  FREE_FINE_WINE_UPGRADE: "free-fw-upgrade",
  SATISFACTION_GUARANTEE: "satisfaction_guarantee",
  MX_COMPLIMENTARY: "mx_complimentary",
};

export const FREE_WINE_SOURCES = [
  CREATION_SOURCES.INTRO_BONUS,
  CREATION_SOURCES.FREE_RECURRING,
  CREATION_SOURCES.SATISFACTION_GUARANTEE,
  CREATION_SOURCES.MX_COMPLIMENTARY,
  // TODO: Integrate CREATION_SOURCES.BONUS when bonus creation source is integrated into Wine as Currency framework
];

export const SOURCE_VALUES = {
  DEFAULT: "Default",
  FWC_UPGRADE: "fwc-upgrade",
  INTRO_BONUS: "intro-bonus",
};

export const LINE_ATTRIBUTE_KEYS = {
  SOURCE: "_Source",
  UPGRADE: "Upgrade",
};

export const BOX_FILLING_BENEFIT_TYPES = {
  FINE_WINE_OPT_IN: "fine_wine_opt_in",
  INTRO_BONUS: "intro_bonus",
};

export const FREE_WINE_DISCLAIMER =
  "*Additional bottles of free wine are included in the total price of the order.";

export const INTRO_BONUS_BENEFIT = {
  quantity: 1,
  fine_wine: false,
  upgrade: false,
  type: BOX_FILLING_BENEFIT_TYPES.INTRO_BONUS,
};

export const FINE_WINE_PRICE = 10;

/**
 * Constants representing different box compositions and default values.
 * @enum {string}
 */
export const BOX_COMPOSITIONS = {
  SIX_X_ONE: "6x1",
  SIX_X_TWO: "6x2",
  THREE_X_ONE: "3x1",
  THREE_X_TWO: "3x2",
  TWELVE_X_ONE: "12x1",
  DEFAULT: "6x1",
  /** Default box composition for double orders (DYO) commands (i.e query, checkout dyo toggle, dyo modal, membership toggle) */
  DEFAULT_DYO_TO_BOX_COMPOSITION: "12x1",
};

/**
 * Constants representing different pricing plans and default values.
 * @enum {string}
 */
export const PRICING_PLANS = {
  CLASSIC: "classic",
  PREFERRED: "preferred",
  PREMIER: "premier",
  FINE_WINE: "fine_wine_plan",
};

export const DEFAULT_PRICING_PLAN = PRICING_PLANS.CLASSIC;

// Quiz
export const THUMBS_UP = 1;
export const THUMBS_DOWN = -1;
export const NOT_SURE = 0;

export const CUSTOM_INTRO_PACK_NAME = "custom-intro";

export const QUIZ_RESULTS_FAQ = [
  {
    value: "item-1",
    question: "How does Firstleaf shipping work?",
    answer: `Once placed, orders typically arrive within 2-5 days. Please note
      that someone over the age of 21 must sign for the package and show
      ID. You can also have your order shipped to a business address or a
      UPS or FedEx store for pick up where they will hold your package for
      up to a week. Your first club order is automatically scheduled for
      28 days after your introductory order and will then repeat at your
      selected interval of every 2 to 12 weeks. You can update these
      frequency settings in your account at any time more than 2 days
      prior to your next order. We will always email you before sending
      your next order.`,
  },
  {
    value: "item-2",
    question: "What if I don't like the Firstleaf wines after I try them?",
    answer: `We want you to enjoy every wine we send you. If you're not satisfied
      with a wine after you've tried it, reach out to us at
      service@firstleaf.com within 30 days of delivery and we'll credit
      you for the bottle (minus shipping) where the law allows. Don't
      forget to rate all the wines you've tried. We use your feedback to
      help improve our matches for you. We also make it easy to swap
      bottles in future orders. You can even work with a Wine Concierge to
      exclude certain varietals from all shipments.`,
  },
  {
    value: "item-3",
    question: "What happens after my first Firstleaf order?",
    answer: `Job One: enjoy your wines! Then make sure to rate each bottle within
      30 days to get a $10 credit toward your next order. Our wine experts
      use your feedback to learn more about your tastes and help improve
      our selections for your future shipments. If you've placed a
      6-bottle or 12-bottle introductory order, you'll continue to receive
      the same number of wines in future shipments. It's easy to change
      the bottle quantity, and other preferences. Just call us at
      1-800-461-7203 or go to Firstleaf.com/club-orders and click on Wine
      Preferences.`,
  },
];

export const RATINGS_FAQ = [
  {
    value: "item-1",
    question: "How do ratings work?",
    answer: `Our rating system uses your feedback to refine the personalized wine selections we send you. It’s easy—just rate each wine you receive with a thumbs up or a thumbs down. A thumbs up means you enjoyed the wine. A thumbs down means it wasn’t for you. You can also leave a note about each wine, which our Wine Concierge will take into account if you reach out for specific recommendations. However, these notes/reviews will not exclude certain types of wine from your orders.`,
  },
  {
    value: "item-2",
    question: "What if I feel neutral about a wine?",
    answer: `To ensure you receive the most personalized selections, we highly encourage you to rate every wine with a thumbs up (I would drink this again) or a thumbs down (I would not). To rate a wine “neutral,” you have to click either the thumbs up or thumbs down button, then unclick it.`,
  },
  {
    value: "item-3",
    question: "What is a Favorite?",
    answer: [
      `Tap the heart to Favorite a wine you absolutely love. Favorited wines count as likes for your recommendations, and they’re the wines you can pick as `,
      { text: "Favorites", href: "/a/sub/club-orders/favorites" },
      ` from your Club Orders page to always add to upcoming boxes.`,
    ],
  },
];
